// The nine dimensions the API allows in a stored targeting filter. PLATFORM and CODE_PUSH_VERSION
// are mobile-only: web cannot evaluate them, so an announcement carrying one is skipped.
enum AnnouncementFilterField {
  APP_VERSION = "appVersion",
  CODE_PUSH_VERSION = "codePushVersion",
  ORG_ADD_ONS = "orgAddOns",
  ORG_ID = "orgId",
  PAGE_ID = "pageId",
  PLATFORM = "platform",
  ROLE_KEY = "roleKey",
  USER_ADD_ONS = "userAddOns",
  USER_ID = "userId",
}

export default AnnouncementFilterField;
